export default __webpack_public_path__ + "static/media/05_Service_and_Customer_Standards_Guidelines.a05803a0.pdf";